import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {getLastFieldInPath, checkIfValuesAre, hasChildren} from 'common/utils';
import {rulesMap} from 'go/components/rules/rules';
import ReactHtmlParser from 'react-html-parser';
import {connectWithCore} from 'framework/hocs';
import DeprecatedDynamicComponent from 'app-ui-componentlibrary/dist/go/components/dynamic/DeprecatedDynamicComponent';

// see src/framework/hocs/connectWithCore, exporting from this file for reverse compatibility, please import directly from core/hocs in the future
// this HOC replaces the below component functionally
export const connectDynamic = connectWithCore;

// component definition moved to DeprecatedDynamicComponent for legacy purposes, do not use this component ever
export const DynamicComponent = DeprecatedDynamicComponent;
export default DeprecatedDynamicComponent;
